<template>
  <a-base-component :subscribed_modules="subscribed_modules">
    <template v-slot:default>
      <!-- <div
        class="d-flex justify-center align-center mb-3 mt-4"
        style="width:100%"
      >
        <div class="mr-2">
          <div
            class="rounded-pill white d-flex align-center justify-space-between py-1 px-1"
            style="height: 100%; position: relative;"
          >
            <v-btn
              small
              rounded
              fab
              :text="tab_view !== 'table'"
              :color="tab_view === 'table' ? 'secondary' : 'black'"
              @click="tab_view = 'table'"
            >
              <v-icon small :color="tab_view === 'table' ? 'white' : 'black'">
                mdi-table-large
              </v-icon>
            </v-btn>
            <v-btn
              small
              rounded
              fab
              :text="tab_view !== 'chart'"
              :color="tab_view === 'chart' ? 'secondary' : 'black'"
              @click="tab_view = 'chart'"
              class="ml-2"
            >
              <v-icon small :color="tab_view === 'chart' ? 'white' : 'black'">
                mdi-equalizer
              </v-icon>
            </v-btn>
          </div>
        </div>
      </div> -->

      <div v-show="tab_view === 'table'">
        <div
          class="d-flex justify-end align-center mb-4 mt-2"
          style="width:100%; gap: 5px"
        >
          <a-display-options-container>
            <div class="grey--text caption line-height-1">
              {{ $t("revenue") }}:
            </div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="view-label"
                  :class="use_orr ? 'secondary--text' : 'grey--text'"
                  @click="toggleUseOrr"
                >
                  ORR
                </span>
              </template>
              <span>{{ $t("include_other_room_revenue") }}</span>
            </v-tooltip>
          </a-display-options-container>
          <a-display-options-container>
            <div class="grey--text caption line-height-1">
              {{ $t("comparative") }}:
            </div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  :color="kpi_mode === 'relative' ? 'secondary' : 'grey'"
                  :class="kpi_mode === 'relative' ? 'active' : ''"
                  @click="setKpiMode('relative')"
                >
                  mdi-percent-outline
                </v-icon>
              </template>
              <span>{{ $t("percentage") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  :color="kpi_mode === 'absolute' ? 'secondary' : 'grey'"
                  :class="kpi_mode === 'absolute' ? 'active' : ''"
                  @click="setKpiMode('absolute')"
                >
                  mdi-counter
                </v-icon>
              </template>
              <span>{{ $t("absolute") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  :color="kpi_mode === 'hide_vs' ? 'secondary' : 'grey'"
                  :class="kpi_mode === 'hide_vs' ? 'active' : ''"
                  @click="setKpiMode('hide_vs')"
                >
                  mdi-circle-off-outline
                </v-icon>
              </template>
              <span>{{ $t("hide_vs") }}</span>
            </v-tooltip>
          </a-display-options-container>
          <a-display-options-container>
            <div class="grey--text caption line-height-1">
              {{ $t("view") }}:
            </div>
            <template>
              <v-tooltip
                bottom
                v-for="(group, index) in year_sales_groups_names"
                :key="'group_' + index"
              >
                <template v-slot:activator="{ on, attrs }" v-if="group">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="view-label"
                    :class="group.isActive ? 'secondary--text' : 'grey--text'"
                    @click="toggleViewGroup(group)"
                  >
                    <template v-if="group.group.startsWith('pickup_')">
                      PU{{ current_hotel.settings.pickup_spots[group.group] }}
                    </template>
                    <template v-else>
                      {{ group.group }}
                    </template>
                  </span>
                </template>
                <span>{{ $t(group.group) }}</span>
              </v-tooltip>
            </template>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="view-label"
                  :class="show_quarters ? 'secondary--text' : 'grey--text'"
                  @click="toggleShowQuarters"
                >
                  Qs
                </span>
              </template>
              <span>{{
                show_quarters ? $t("hide_quarters") : $t("show_quarters")
              }}</span>
            </v-tooltip>
          </a-display-options-container>
        </div>
        <a-rms-year-sales-table
          :configYearSalesTable="configYearSalesTable"
          :monthsValues="monthsValues"
          :quartersValues="quartersValues"
          :yearValues="yearValues"
          :kpiMode="kpi_mode"
          :showQuarters="show_quarters"
        >
        </a-rms-year-sales-table>
      </div>
      <a-rms-year-sales-charts
        v-show="tab_view === 'chart'"
        :monthsGraphData="monthsGraphData"
        :quartersGraphData="quartersGraphData"
        :yearValues="yearValues"
      />
    </template>
    <template v-slot:loading>
      <v-card>
        <v-card-text>
          <v-skeleton-loader
            v-for="i in 12"
            :key="i"
            type="card"
            height="70"
            class="elevation-0 mb-2"
          >
          </v-skeleton-loader>
        </v-card-text>
      </v-card>
    </template>
  </a-base-component>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import aBaseComponent from "@/components/aBaseComponent";
import aRmsYearSalesTable from "@/components/rms/axel/aRmsYearSalesTable.vue";
import aRmsYearSalesCharts from "@/components/rms/axel/aRmsYearSalesCharts.vue";
import aDisplayOptionsContainer from "@/components/aDisplayOptionsContainer";

const year_sales_groups = [
  "otb",
  "stly",
  "ly",
  "bud",
  "forecast",
  "pickup_1",
  "pickup_2",
  "pickup_3"
];

function buildConfigYearSalesTable(useOrr) {
  const revKpi = useOrr ? "accommodation_revenue" : "room_revenue";
  const mainBlock = block => ({
    columns: {
      occupancy: { kpi: "occupancy", block },
      adr: { kpi: "adr", block },
      revpar: { kpi: "revpar", block },
      room_revenue: { kpi: revKpi, block }
    }
  });
  const pickupBlock = block => ({
    columns: {
      rn: { kpi: "rn_adr", block },
      adr: { kpi: "adr", block },
      room_revenue: { kpi: revKpi, block }
    }
  });

  return {
    "": { columns: { date: {} }, icon: null },
    otb: mainBlock("otb"),
    stly: mainBlock("stly"),
    ly: mainBlock("ly"),
    bud: mainBlock("bud"),
    forecast: mainBlock("forecast"),
    pickup_1: pickupBlock("pickup_1"),
    pickup_2: pickupBlock("pickup_2"),
    pickup_3: pickupBlock("pickup_3")
  };
}

export default {
  name: "a-rms-year-sales",
  components: {
    aBaseComponent,
    aDisplayOptionsContainer,
    aRmsYearSalesTable,
    aRmsYearSalesCharts
  },
  props: {
    event_period: {
      type: Array,
      default: () => []
    },
    tab_view: {
      type: String,
      default: "table"
    }
  },
  data: vm => ({
    title: "",
    subscribed_modules: [
      // "rate_available_rate_extractions",
      // "rms_all_kpis_daily_dimension",
      "rms_kpis_year_sales_months",
      "rms_kpis_year_sales_quarters",
      "rms_kpis_year_sales_year"
      // "rms_all_kpis_daily_compset"
    ],
    year_sales_groups_names: year_sales_groups.map(group => ({
      group,
      isActive: true
    })),
    kpi_mode: "relative",
    show_quarters: false,
    use_orr: true
  }),
  methods: {
    saveUserSettings() {
      if (!this.current_user) this.current_user = {};
      if (!this.current_user.settings) this.current_user.settings = {};
      if (!this.current_user.settings["rms_year_sales"])
        this.current_user.settings["rms_year_sales"] = {};
      if (!this.current_user.settings["rms_year_sales"]["0"])
        this.current_user.settings["rms_year_sales"]["0"] = {};

      let stored = {
        ...this.current_user.settings["rms_year_sales"]["0"]
      };
      stored.comparative = this.kpi_mode;
      stored.use_orr = this.use_orr;
      stored.show_quarters = this.show_quarters;
      stored.year_sales_groups = this.year_sales_groups_names.map(g => ({
        group: g.group,
        isActive: g.isActive
      }));

      this.current_user.settings["rms_year_sales"]["0"] = stored;

      this.$store.dispatch("setRmsYearSalesUserSettings", {
        settings: stored,
        hotel_id: "0"
      });
    },
    setInitFilters() {
      if (
        this.user_settings &&
        this.user_settings.rms_year_sales &&
        this.user_settings.rms_year_sales["0"]
      ) {
        const user_data = this.user_settings.rms_year_sales["0"];

        if (user_data.comparative) {
          this.kpi_mode = user_data.comparative;
        }
        if (typeof user_data.use_orr === "boolean") {
          this.use_orr = user_data.use_orr;
        }
        if (typeof user_data.show_quarters === "boolean") {
          this.show_quarters = user_data.show_quarters;
        }
        if (Array.isArray(user_data.year_sales_groups)) {
          for (const g of user_data.year_sales_groups) {
            const row = this.year_sales_groups_names.find(
              x => x.group === g.group
            );
            if (row && typeof g.isActive === "boolean") {
              row.isActive = g.isActive;
            }
          }
        }
      }
    },
    setKpiMode(mode) {
      this.kpi_mode = mode;
      this.saveUserSettings();
    },
    toggleUseOrr() {
      this.use_orr = !this.use_orr;
      this.saveUserSettings();
    },
    toggleShowQuarters() {
      this.show_quarters = !this.show_quarters;
      this.saveUserSettings();
    },
    toggleViewGroup(group) {
      group.isActive = !group.isActive;
      this.saveUserSettings();
    }
  },
  watch: {
    monthsValues() {
      this.monthsGraphData = {
        kpis: this.series_monthly,
        labels: this.labels_monthly
      };
    },
    quartersValues() {
      this.quartersGraphData = {
        kpis: this.series_quarterly,
        labels: this.labels_quarterly
      };
    },
    user_settings() {
      if (this.user_settings) {
        this.setInitFilters();
      }
    }
  },
  computed: {
    monthsValues() {
      return this.rms.kpis_year_sales_months;
    },
    quartersValues() {
      const quarters = {
        q1: this.rms.kpis_year_sales_q1,
        q2: this.rms.kpis_year_sales_q2,
        q3: this.rms.kpis_year_sales_q3,
        q4: this.rms.kpis_year_sales_q4
      };
      return { ...quarters };
    },
    yearValues() {
      return this.rms.kpis_year_sales_year;
    },
    configYearSalesTable() {
      const table = buildConfigYearSalesTable(this.use_orr);
      return {
        "": table[""],
        ...this.year_sales_groups_names.reduce((acc, cur) => {
          if (cur.isActive) {
            acc[cur.group] = table[cur.group];
          }
          return acc;
        }, {})
      };
    },
    monthsGraphData: {
      get() {
        return this.rms.kpis_year_sales_months_graph;
      },
      set(value) {
        this.$store.commit("GET_DATASET", {
          dataset: "kpis_year_sales_months_graph",
          data: value
        });
      }
    },
    quartersGraphData: {
      get() {
        return this.rms.kpis_year_sales_quarters_graph;
      },
      set(value) {
        this.$store.commit("GET_DATASET", {
          dataset: "kpis_year_sales_quarters_graph",
          data: value
        });
      }
    },
    series_monthly() {
      return this.keys_monthly.reduce((acc, key) => {
        Object.keys(this.monthsValues[key].otb).forEach(kpi => {
          if (!acc[kpi]) {
            acc[kpi] = {
              otb: [],
              stly: []
            };
          }
          acc[kpi].otb.push(this.monthsValues[key].otb[kpi]);
          acc[kpi].stly.push(this.monthsValues[key].stly[kpi]);
        });
        return acc;
      }, {});
    },
    series_quarterly() {
      return this.labels_quarterly.reduce((acc, key) => {
        Object.keys(this.quartersValues[key].otb).forEach(kpi => {
          if (!acc[kpi]) {
            acc[kpi] = {
              otb: [],
              stly: []
            };
          }
          acc[kpi].otb.push(this.quartersValues[key].otb[kpi]);
          acc[kpi].stly.push(this.quartersValues[key].stly[kpi]);
        });
        return acc;
      }, {});
    },
    keys_monthly() {
      return Object.keys(this.monthsValues);
    },
    labels_monthly() {
      return this.keys_monthly.map(key =>
        Vue.moment(`${key}-01`).format("MMM")
      );
    },
    labels_quarterly() {
      return Object.keys(this.quartersValues);
    },
    ...mapState({
      rms: state => state.rms,
      available_rate_extractions: state => state.rate.available_rate_extractions
    }),
    ...mapGetters({
      current_hotel: "current_hotel",
      current_user: "current_user",
      user_settings: "getUserSettings"
    })
  },
  mounted() {
    if (this.user_settings) {
      this.setInitFilters();
    }
  }
};
</script>
<style lang="scss">
.view-label {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  cursor: pointer;
  letter-spacing: 0.3px;
  user-select: none;
}

.v-list--dense .v-list-item {
  min-height: 33px;
}

.v-date-picker-title__date {
  font-size: 16px;
}

.cols7 {
  width: calc(100% / 7);
  max-width: calc(100% / 7);
  flex-basis: calc(100% / 7);
}

$height: 19px;
.a-rms-day {
  font-size: 11px;
  line-height: height;
  text-align: right;

  &:focus::before {
    background: white;
  }

  .a-rms-day-row-day {
    height: $height;
    font-weight: 600;
    text-transform: uppercase;
    color: #444444;
    letter-spacing: -0.5px;
  }

  .a-rms-day-row-header {
    font-size: 11px;
    font-weight: 500;
    color: #666666;
    text-transform: uppercase;
    height: $height;
    overflow: hidden;
    letter-spacing: -0.5px;
  }

  .a-rms-day-row {
    height: $height;
    overflow: hidden;
    display: flex;
    align-items: center;
  }

  .a-rms-day-row-resume {
    height: $height;
    font-weight: 600;
    // border-top: 1px solid #e5e5e5;
    overflow: hidden;
    // padding-top: 5px;
    // margin-top: 5px;
  }
}

.day_details_mini {
  position: fixed;
  width: 90%;
  bottom: 20px;
  border-radius: 15px;
  overflow: hidden;
  z-index: 20;
}
</style>
